/**
 * Returns undefinend if the object has no defined properties
 * @param {*} obj
 * @returns
 */
export const cleanObject = (obj) => {
	const hasValues = Object.values(obj).some((v) => v !== undefined);
	return hasValues ? obj : undefined;
};

export const getPropertyValueByCaseInsensitiveName = (object, propertyName) => {
	const propertyKey = Object.keys(object || {}).find(
		(key) => key.toLowerCase() === propertyName.toLowerCase()
	);

	return propertyKey ? object[propertyKey] : undefined;
};
